<template>
  <el-table
    :data="monedaList"
    border
    stripe
  >
    <el-table-column
      prop="CodigoInternacional"
      label="Código"
      width="90"
      align="center"
    />
    <el-table-column
      prop="Descripcion"
      label="Descripción"
      align="center"
    />
    <el-table-column
      label="Moneda Principal"
      width="150"
      align="center"
    >
      <template #default="{ row }">
        <el-radio
          v-model="monedaPrincipalSeleccionada"
          :label="row.Codigo"
          @change="setMonedaPrincipal(row)"
        >
          Principal
        </el-radio>
      </template>
    </el-table-column>
    <el-table-column label="Compra">
      <template #default="{ row }">
        <custom-input-number
          v-model="row.CotizacionCompra"
          :settings="{
            placeholder: 'Cotizacion Compra',
            min: 0,
            disabled: !row._editing,
            precision: 2,
            step: 0.01,
            controls: false,
          }"
          @change="() => edit(row)"
        ></custom-input-number>
      </template>
    </el-table-column>
    <el-table-column label="Venta">
      <template #default="{ row }">
        <custom-input-number
          v-model="row.CotizacionVenta"
          :settings="{
            placeholder: 'Cotizacion Venta',
            disabled: !row._editing,
            min: 0,
            precision: 2,
            step: 0.01,
            controls: false,
          }"
          @change="() => edit(row)"
        ></custom-input-number>
      </template>
    </el-table-column>
    <el-table-column
      label="Acciones"
      width="120"
      align="center"
    >
      <template #default="{ row }">
        <el-button
          :icon="IconEdit"
          @click="toggleEdit(row)"
        ></el-button>
      </template>
    </el-table-column>
  </el-table>

  <div class="actions-bar">
    <el-button
      type="primary"
      size="default"
      @click="onSave"
    >
      Guardar todos
    </el-button>
  </div>
</template>

<script setup>
import {
  onMounted,
  ref,
  watch,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useMonedaStore } from '@/stores/moneda/moneda_store.js';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import IconEdit from '~icons/mdi/edit';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';

const monedaStore = useMonedaStore();
const { monedaList } = storeToRefs(monedaStore);
const { updateMonedasHTTP, findAllMonedaHTTP } = monedaStore;
const monedaPrincipalSeleccionada = ref(null);

onMounted(() => {
  findAllMonedaHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
});

const edit = (row) => {
  row.edit = true;
};
const toggleEdit = (row) => {
  row._editing = !row._editing;
};

const onSave = async () => {
  useLoading().openLoading();
  const toSave = monedaList.value.filter((row) => row.edit);
  if (toSave.length === 0) {
    useMessageSuccess().open('No hay cambios para guardar');
    useLoading().closeLoading();
    return;
  }
  try {
    await updateMonedasHTTP(toSave);
    useMessageSuccess().open('Cotizaciones guardadas correctamente');
    toSave.forEach((row) => {
      row.edit = false;
      row._editing = false;
    });
  } catch (err) {
    console.error(err);
    useMessageError().open('Error al guardar cotizaciones');
  } finally {
    useLoading().closeLoading();
  }
};

const setMonedaPrincipal = (row) => {
  monedaList.value.forEach((m) => {
    m.EsMonedaPrincipal = m.Codigo === row.Codigo;
    m.edit = true;
  });
};

watch(
  monedaList,
  (newList) => {
    if (newList && newList.length > 0 && !monedaPrincipalSeleccionada.value) {
      const principal = newList.find((m) => m.EsMonedaPrincipal);
      if (principal) {
        monedaPrincipalSeleccionada.value = principal.Codigo;
      }
    }
  },
  { immediate: true },
);
</script>

<style scoped>
.actions-bar {
  width: 100%;
  text-align: right;
  margin-top: 16px;
}
</style>
